// Listas de opções do formulário de imóvel — mesmas opções (e mesma ordem
// de "padrão") do painel legado (`admin/imovel/_form.blade.php`). A PRIMEIRA
// de cada lista é o valor inicial de um imóvel novo, como no legado.

export const CATEGORIAS = ['Normal', 'Cobertura', 'Duplex', 'Flat', 'Kitnet', 'Sobrado', 'Terreno'];
export const FINALIDADES = ['Residencial', 'Comercial', 'Industrial', 'Rural', 'Temporada'];
export const FINANCIAMENTOS = ['Não aceita', 'Aceita'];
export const PGTO_IPTU = ['', 'Mensal', 'Anual'];
// O legado só oferece Inativo/Ativo (Locado, Permutado etc. estão comentados),
// e um imóvel novo já nascia "Inativo" (primeira opção).
export const SITUACOES = ['Inativo', 'Ativo'];
export const ESTADOS_ATUAIS = ['Usado', 'Novo', 'Em construção', 'Lançamento'];
export const OCUPACOES = ['Proprietário', 'Desocupado', 'Inquilino', 'Construtora'];
export const PADROES = ['Regular', 'Super Alto', 'Alto', 'Médio', 'Baixo'];
export const LOCALIZACOES = ['Regular', 'Privilegiada', 'Ótima', 'Boa', 'Ruim'];
export const MEDIDAS = ['M²', 'Alqueires', 'Hectares'];
export const FACES = [
  '', 'Norte', 'Sul', 'Leste', 'Oeste', 'Norte/Leste', 'Norte/Oeste', 'Sul/Leste', 'Sul/Oeste',
  'Leste/Norte', 'Leste/Sul', 'Oeste/Norte', 'Oeste/Sul',
];
export const ISOLAMENTOS = ['', 'Isolada', 'Germinada', 'Semi-Germinada', 'Paralela'];
export const POSICOES = ['', 'Frente', 'Fundo', 'Lateral', 'Meio', 'Esquina'];

export const ESTADOS_BR = [
  ['AC', 'Acre'], ['AL', 'Alagoas'], ['AP', 'Amapá'], ['AM', 'Amazonas'], ['BA', 'Bahia'], ['CE', 'Ceará'],
  ['DF', 'Distrito Federal'], ['ES', 'Espírito Santo'], ['GO', 'Goiás'], ['MA', 'Maranhão'],
  ['MT', 'Mato Grosso'], ['MS', 'Mato Grosso do Sul'], ['MG', 'Minas Gerais'], ['PA', 'Pará'],
  ['PB', 'Paraíba'], ['PR', 'Paraná'], ['PE', 'Pernambuco'], ['PI', 'Piauí'], ['RJ', 'Rio de Janeiro'],
  ['RN', 'Rio Grande do Norte'], ['RS', 'Rio Grande do Sul'], ['RO', 'Rondônia'], ['RR', 'Roraima'],
  ['SC', 'Santa Catarina'], ['SP', 'São Paulo'], ['SE', 'Sergipe'], ['TO', 'Tocantins'],
];

// Campos do formulário, por tipo de tratamento.
export const CAMPOS_DINHEIRO = [
  'i1_vlrvenda', 'i1_locacao', 'i1_temporada', 'i1_estudante', 'i1_vlrcondominio', 'i1_vlriptu',
  'i1_veiculopermuta', 'i1_imovelpermuta',
];

export const CAMPOS_BOOLEANOS = [
  'i1_siteempresa', 'i1_oportunidadeneg', 'i1_destaque', 'i1_vlrsobconsul', 'i1_vlrnegoci',
  'i1_vlrsitedarede', 'i1_univentv', 'i1_portais', 'i1_autorizado', 'i1_emparceria',
  'i1_documentacao', 'i1_possuicondominio', 'i1_permuta', 'i1_financiado',
];

// Texto e números (tudo string no formulário; o servidor converte).
export const CAMPOS_TEXTO = [
  'i1_tipo', 'i1_categoria', 'i1_finalidade', 'i1_financiamento', 'i1_pgtoiptu', 'i1_situacao',
  'i1_estadoatual', 'i1_ocupacao', 'i1_referencia', 'i1_padrao', 'i1_localizacao', 'i1_descrinterna',
  'i1_cep', 'i1_endereco', 'i1_numero', 'i1_bairroofi', 'i1_cidade', 'i1_estado', 'i1_complemento',
  'i1_quadra', 'i1_lote', 'i1_condominio', 'i1_latitude', 'i1_longitude',
  'i1_qtddormitorios', 'i1_qtdsuites', 'i1_qtdsuitescloset', 'i1_qtddemisuites', 'i1_qtdsalas',
  'i1_qtdsaladeestar', 'i1_qtdsaladejantar', 'i1_qtdsaladetv', 'i1_qtdgaragens', 'i1_qtdgaragenscobertas',
  'i1_qtdgaragensdescobertas', 'i1_qtdbanheiros', 'i1_qtdandares', 'i1_qtdelevadores', 'i1_qtdambientes',
  'i1_construida', 'i1_util', 'i1_totalterreno', 'i1_comum', 'i1_privativa', 'i1_total', 'i1_pedireito',
  'i1_medida', 'i1_dimensaoterreno', 'i1_face', 'i1_isolamento', 'i1_posicao', 'i1_distanciamar',
  'i1_seotitulo', 'i1_descricao', 'i1_seoplvrchave', 'i1_seodescricao',
  'i1_cadprefeitura', 'i1_cartorio', 'i1_eletrecidade', 'i1_aguaesaneamento', 'i1_youtube',
];

// Valor inicial de um imóvel NOVO (primeira opção de cada lista, como no legado).
export const PADROES_NOVO = {
  i1_categoria: CATEGORIAS[0],
  i1_finalidade: FINALIDADES[0],
  i1_financiamento: FINANCIAMENTOS[0],
  i1_pgtoiptu: PGTO_IPTU[0],
  i1_situacao: SITUACOES[0],
  i1_estadoatual: ESTADOS_ATUAIS[0],
  i1_ocupacao: OCUPACOES[0],
  i1_padrao: PADROES[0],
  i1_localizacao: LOCALIZACOES[0],
  i1_medida: MEDIDAS[0],
  i1_estado: 'SP',
};

// Checkboxes já marcados num imóvel NOVO (pedido do Jason, 28/09/2026) — os outros
// booleanos de CAMPOS_BOOLEANOS continuam desmarcados por padrão.
export const PADROES_NOVO_BOOLEANOS = [
  'i1_siteempresa', 'i1_oportunidadeneg', 'i1_destaque', 'i1_vlrnegoci',
  'i1_vlrsitedarede', 'i1_univentv', 'i1_portais', 'i1_autorizado',
];

// Campos que faltam pro imóvel sair de "rascunho" (mesma lista do servidor).
export const CAMPOS_PUBLICAR = [
  ['i1_seotitulo', 'Título do imóvel'],
  ['i1_descricao', 'Descrição'],
  ['proprietario', 'Proprietário'],
  ['i1_endereco', 'Endereço'],
  ['i1_numero', 'Número'],
  ['i1_cep', 'CEP'],
  ['i1_bairroofi', 'Bairro'],
  ['i1_cidade', 'Cidade'],
  ['i1_estado', 'Estado'],
  ['i1_totalterreno', 'Total do terreno'],
];
